export default __webpack_public_path__ + "static/media/Cadillac.5df7ef82.png";